import React from 'react';
import { usePageTracking } from '../../hooks/usePageTracking';

export const GoolgeAnalyticsPageTracker = ({ gtmTrackingId }) => {
  usePageTracking(gtmTrackingId);
  return <></>;
};